module.exports = __webpack_public_path__ + "static/media/Sample-Listening-Multiple-Choice-One-Answer-trimmed.9cf92314.mp3";